import React, { useEffect, useRef, useState } from "react";

import {
  RideGlMoneyOutline,
  RideButton,
  RideGlDown,
} from "@rimac-seguros/ride-system-components";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";

import { formatAmountThousand } from "@/utils/Utils";
import loadingAnimated from "@/assets/animation/loading-animated.json";

import "./styles.scss";

export const CardDetailPlan = ({
  isLoadingData = false,
  callAnalyticsAction,
}) => {
  const [showMore, setShowMore] = useState(true);

  const { nameFrequency, typeOfFinancing, planSelected } = useSelector(
    (state) => state.plans
  );

  const lottieRef = useRef();

  const { devolucionTotal, pagoMensual, aporteTotal, gananciaTotal } =
    typeOfFinancing || {};
  const { sumAssured, savingTime, returnPercentage } = planSelected || {};

  const list = [
    {
      text: `En ${savingTime?.text} años recibirás`,
      value: `S/${formatAmountThousand(
        Number(devolucionTotal || 0).toFixed(2)
      )}`,
      isBold: true,
      hasAnimation: isLoadingData,
    },
    {
      text: `Pago ${nameFrequency.toLowerCase()}`,
      value: `S/${formatAmountThousand(Number(pagoMensual || 0).toFixed(2))}`,
      hasAnimation: isLoadingData,
    },
    {
      text: "Aporte total",
      value: `S/${formatAmountThousand(Number(aporteTotal || 0).toFixed(2))}`,
      hasAnimation: isLoadingData,
    },
    {
      text: "Ganancia extra",
      additionalText:
        returnPercentage?.text === "100%"
          ? "(Eligiendo desde un 115% de devolución)"
          : "",
      value: `S/${formatAmountThousand(Number(gananciaTotal || 0).toFixed(2))}`,
      hasAnimation: isLoadingData,
    },
    {
      text: "Cobertura por fallecimiento",
      value: sumAssured?.text,
    },
    {
      text: "Tiempo de ahorro",
      value: `${savingTime?.text} años`,
    },
    {
      text: "Porcentaje de devolución",
      value: returnPercentage?.text,
    },
    {
      text: "Frecuencia de pago",
      value: nameFrequency,
    },
  ];

  useEffect(() => {
    if (lottieRef) {
      lottieRef?.current?.setSpeed(1.5);
    }
  }, [lottieRef]);

  const handleClickAction = () => {
    if (!showMore) {
      callAnalyticsAction();
    }
    setShowMore(!showMore);
  };

  return (
    <div className="w-full border rounded-ride-sys-border-radius-container-large border-ride-sys-color-border-default lg:sticky lg:top-24">
      <div className="pb-0 p-ride-gl-spacing-5xlarge">
        <div className="flex items-center justify-between border-b pb-ride-gl-spacing-2xlarge border-ride-sys-color-border-default">
          <h2 className="ride-sys-text-title-2xlarge-default">
            Resumen de tu ahorro:
          </h2>
          <RideGlMoneyOutline size="2x-large" />
        </div>
        <div
          className={`flex flex-col gap-ride-gl-spacing-large mt-ride-gl-spacing-2xlarge ${
            showMore ? "expand" : "collapse"
          }`}
        >
          {list.slice(0, showMore ? list.length : 2).map((item) => (
            <div
              key={item.text}
              className={`flex justify-between items-center relative ${
                item.isBold
                  ? "ride-sys-text-paragraph-large-bold"
                  : "ride-sys-text-paragraph-medium-default"
              }`}
            >
              <span>
                {item.text}
                {item.additionalText && (
                  <span className="block ride-sys-text-label-small-regular">
                    {item.additionalText}
                  </span>
                )}
              </span>
              <span className={`capitalize ${item.isBold ? 'ride-sys-text-title-2xlarge-default' : ''}`}>
                {item.hasAnimation ? (
                  <Lottie
                    lottieRef={lottieRef}
                    animationData={loadingAnimated}
                    autoplay
                    className="card-detail-plan_animated-amount"
                  />
                ) : (
                  item.value
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t mt-ride-gl-spacing-5xlarge border-ride-sys-color-border-default">
        <RideButton
          text={!showMore ? "Ver más" : "Ver menos"}
          variant="text-primary"
          size="large"
          glyph={
            <RideGlDown
              className={
                showMore ? "transform rotate-180 transition-all delay-200" : ""
              }
            />
          }
          glyphPosition="right"
          className="w-full"
          disabled={isLoadingData}
          onClick={handleClickAction}
        />
      </div>
    </div>
  );
};
